import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "textFields", "imageFields", "urlFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.selectTarget.value

    this.textFieldsTarget.style.display = value === "text_header" ? "" : "none"
    this.imageFieldsTarget.style.display = value === "image_header" ? "" : "none"
    this.urlFieldsTarget.style.display = (value === "document_header" || value === "video_header") ? "" : "none"

    // Disable hidden inputs so they don't submit empty values
    this.textFieldsTarget.querySelectorAll("input").forEach(i => i.disabled = value !== "text_header")
    this.urlFieldsTarget.querySelectorAll("input").forEach(i => i.disabled = (value !== "document_header" && value !== "video_header"))
  }
}
